import { init as initApm, AgentConfigOptions, ApmBase } from '@elastic/apm-rum'
import { configService } from '@/services/config-service'

class SingletonLogger {
  static instance?: ApmBase
  static config = {
    serviceName: 'nzm-grower-gateway-client',
    serverUrl: configService().get('ELASTIC_APM_ENDPOINT'),
    active: configService().get('ELASTIC_APM_ACTIVE'),
    instrument: true,
    distributedTracing: configService().get('ELASTIC_APM_DISTRIBUTED_TRACING_ACTIVE'),
    disableInstrumentations: configService().get('ELASTIC_APM_DISABLE_INSTRUMENTATIONS'),
    environment: configService().get('ENV'),
    logLevel: configService().get('ELASTIC_APM_LOG_LEVEL'),
  }

  /**
   * The Singleton's constructor should always be private to prevent direct
   * construction calls with the `new` operator.
   */
  private constructor() {}

  static getInstance() {
    if (!this.instance && configService().get('ELASTIC_APM_ACTIVE')) {
      this.instance = initApm(this.config as AgentConfigOptions)
    }
    return this.instance
  }
}

export const loggingService = SingletonLogger.getInstance()
